import React, { useEffect, useRef, useState } from "react";

const formatDate = (raw) => {
  if (!raw || raw.length < 6) return "Invalid";
  const year = "20" + raw.slice(0, 2);
  const month = raw.slice(2, 4);
  const day = raw.slice(4, 6);
  return `${year}-${month}-${day}`;
};

const parseTrack1 = (rawData) => {
  const match = rawData.match(
    /%B(\d{6})(\d{10})\^([A-Z]+)\/([\w\s]+)\^(\d{6,7})\d(\d{8})([A-Z]{2})[A-Z]*\s*(\d{6})/
  );

  if (!match) return null;

  const [
    ,
    _bin,
    hcNumber,
    lastName,
    firstNamesRaw,
    expRaw,
    dobRaw,
    versionCode,
    issueRaw,
  ] = match;

  const [firstName, ...middleParts] = firstNamesRaw.trim().split(" ");
  const middleName = middleParts.join(" ");

  return {
    hcNumber,
    versionCode,
    lastName,
    firstName,
    middleName,
    dob: `${dobRaw.slice(0, 4)}-${dobRaw.slice(4, 6)}-${dobRaw.slice(6, 8)}`,
    issued: formatDate(issueRaw),
    expires: formatDate(expRaw),
    expiresRaw: expRaw,
  };
};

const parseTrack2 = (rawData) => {
  const match = rawData.match(/;(\d{10,19})=(\d{6})9/);
  if (!match) return null;
  const [, , exp] = match;
  return { expiryRaw: exp };
};

const CopyField = ({ label, value }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <div style={{ marginBottom: "10px" }}>
      <strong>{label}:</strong> {value}{" "}
      <button onClick={handleCopy} style={{ marginLeft: "10px" }}>
        📋 Copy
      </button>
      {copied && (
        <span style={{ color: "green", marginLeft: "10px" }}>Copied!</span>
      )}
    </div>
  );
};

const OntarioHealthCardScanner = () => {
  const [cardData, setCardData] = useState(null);
  const [validSwipe, setValidSwipe] = useState(null);
  const trackBuffer = useRef({ track1: "", track2: "" });
  const currentBuffer = useRef("");
  const containerRef = useRef();

  useEffect(() => {
    const handleKeyPress = (e) => {
      const char = e.key;
      if (!char) return;
      currentBuffer.current += char;

      if (char === "?") {
        const raw = currentBuffer.current.trim().replace(/^Enter/i, "");
        currentBuffer.current = "";

        if (raw.startsWith("%B")) {
          trackBuffer.current.track1 = raw;
        } else if (raw.startsWith(";")) {
          trackBuffer.current.track2 = raw;
        }

        if (trackBuffer.current.track1 && trackBuffer.current.track2) {
          const t1 = parseTrack1(trackBuffer.current.track1);
          const t2 = parseTrack2(trackBuffer.current.track2);
          const isValid = t1?.expiresRaw?.startsWith(t2?.expiryRaw);
          setCardData(t1);
          setValidSwipe(!!t1 && !!t2 && isValid);
          trackBuffer.current = { track1: "", track2: "" };
        }
      }
    };

    const el = containerRef.current;
    el?.focus();
    el?.addEventListener("keypress", handleKeyPress);
    return () => {
      el?.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  const borderColor =
    validSwipe === true ? "green" : validSwipe === false ? "red" : "#ccc";

  return (
    <div
      ref={containerRef}
      tabIndex={0}
      style={{
        padding: "2rem",
        fontFamily: "Arial",
        outline: "none",
        border: `3px solid ${borderColor}`,
        borderRadius: "8px",
      }}
    >
      <h2>Swipe Health Card</h2>
      <p>Click here and swipe the card.</p>

      {cardData ? (
        <div style={{ marginTop: "1rem", lineHeight: "1.8" }}>
          <CopyField
            label="Health Card"
            value={`${cardData.hcNumber}${cardData.versionCode}`}
          />
          <CopyField label="First Name" value={cardData.firstName} />
          <CopyField
            label="Middle Name"
            value={cardData.middleName || "(none)"}
          />
          <CopyField label="Last Name" value={cardData.lastName} />
          <CopyField label="DOB" value={cardData.dob} />
          <div style={{ marginTop: "10px" }}>
            <strong style={{ color: validSwipe ? "green" : "red" }}>
              {validSwipe ? "✅ Swipe Verified" : "❌ Expiry Mismatch"}
            </strong>
          </div>
        </div>
      ) : (
        <p style={{ fontStyle: "italic", color: "#777" }}>Awaiting swipe...</p>
      )}
    </div>
  );
};

export default OntarioHealthCardScanner;
